import dayjs from "dayjs"
import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore"
import { InvoicePaymentType } from "../Enum"
import { Invoice } from "../Type"
import { fixInvoiceDate, formatDateTime } from "../utils/DateUtils"

export const getEmptyInvoice = (): Invoice => {
  return {
    id: "",
    date: formatDateTime(),
    dueDate: "",
    name: "",
    buyerId: "",
    buyerName: "",
    totalItems: 0,
    totalPrice: 0,
    discountRate: 0,
    vatRate: 0,
    invoiceItems: [],
    paymentType: InvoicePaymentType.DRAFT,
    insertDate: dayjs().valueOf(),
    lastEditDate: dayjs().valueOf(),
  }
}

export const getInvoiceFromDocSnapshot = (
  docSnap: QueryDocumentSnapshot<DocumentData, DocumentData>
): Invoice => {
  return {
    id: docSnap.id,
    date: fixInvoiceDate(docSnap.data().date),
    dueDate: docSnap.data().dueDate,
    name: docSnap.data().name,
    buyerId: docSnap.data().buyerId,
    buyerName: docSnap.data().buyerName ? docSnap.data().buyerName : "",
    totalItems: docSnap.data().totalItems,
    totalPrice: docSnap.data().totalPrice,
    discountRate: docSnap.data().discountRate,
    vatRate: docSnap.data().vatRate,
    paymentType: docSnap.data().paymentType,
    insertDate: docSnap.data().insertDate,
    lastEditDate: docSnap.data().lastEditDate,
  }
}
